let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8OkIZ")).then(() => parcelRequire('1Sv3T'));